// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/authz.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EnumValueOptions, MethodOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/authz.proto.
 */
export const file_travplaces_v1_authz: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_descriptor]);

/**
 * PermissionRequirement is one clause the caller has to satisfy.
 *
 * @generated from message travplaces.v1.PermissionRequirement
 */
export type PermissionRequirement = Message<"travplaces.v1.PermissionRequirement"> & {
  /**
   * Holding any one of these — or any ancestor of one — satisfies the clause.
   *
   * @generated from field: repeated travplaces.v1.Permission permissions_any = 1;
   */
  permissionsAny: Permission[];
};

/**
 * Describes the message travplaces.v1.PermissionRequirement.
 * Use `create(PermissionRequirementSchema)` to create a new message.
 */
export const PermissionRequirementSchema: GenMessage<PermissionRequirement> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_authz, 0);

/**
 * Permission is a single capability, granted to roles and demanded by methods.
 *
 * The set is coarse on purpose. A permission per RPC would be a rename of the
 * method list, and would make every new RPC a migration; these name the things
 * an operator would recognise as separate jobs — curating the catalogue,
 * running imports, planning a trip — because those are the lines a role is
 * actually drawn along.
 *
 * Numbers are grouped by area with gaps between the groups, so a new
 * permission can be added next to its relatives rather than at the end.
 *
 * @generated from enum travplaces.v1.Permission
 */
export enum Permission {
  /**
   * @generated from enum value: PERMISSION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The root. Every other permission descends from it, so a role holding it
   * can call everything, including methods added after the grant was made.
   *
   * @generated from enum value: PERMISSION_ALL = 1;
   */
  ALL = 1,

  /**
   * Reading the catalogue: cities, POIs, categories, themes, styles, saved
   * settings. One permission for all of it because there is no use for an
   * account that can see cities but not the categories they are filed under —
   * the console cannot render a usable screen from half of it.
   *
   * @generated from enum value: PERMISSION_CATALOGUE_READ = 10;
   */
  CATALOGUE_READ = 10,

  /**
   * @generated from enum value: PERMISSION_CITY_WRITE = 11;
   */
  CITY_WRITE = 11,

  /**
   * @generated from enum value: PERMISSION_POI_WRITE = 12;
   */
  POI_WRITE = 12,

  /**
   * Categories, category groups, route styles and route themes. Separate from
   * city and POI editing because it is the schema the rest of the catalogue is
   * filed under: an edit here reclassifies every city at once.
   *
   * @generated from enum value: PERMISSION_TAXONOMY_WRITE = 13;
   */
  TAXONOMY_WRITE = 13,

  /**
   * @generated from enum value: PERMISSION_SETTINGS_WRITE = 20;
   */
  SETTINGS_WRITE = 20,

  /**
   * @generated from enum value: PERMISSION_JOB_READ = 21;
   */
  JOB_READ = 21,

  /**
   * Enqueueing and cancelling imports and builds. Held apart from viewing
   * them because these are the expensive, destructive ones: an import rewrites
   * a city's POIs and a build replaces the routing graph underneath everyone
   * currently planning against it.
   *
   * @generated from enum value: PERMISSION_JOB_RUN = 22;
   */
  JOB_RUN = 22,

  /**
   * @generated from enum value: PERMISSION_SYSTEM_STATUS = 23;
   */
  SYSTEM_STATUS = 23,

  /**
   * @generated from enum value: PERMISSION_ENGINE_RESTART = 24;
   */
  ENGINE_RESTART = 24,

  /**
   * @generated from enum value: PERMISSION_PLAN_ROUTE = 30;
   */
  PLAN_ROUTE = 30,

  /**
   * @generated from enum value: PERMISSION_TRIP_MANAGE = 31;
   */
  TRIP_MANAGE = 31,

  /**
   * Calls that leave the building and land on a billable provider API. Its
   * own permission because the cost is the point: every call spends money,
   * whoever makes it.
   *
   * @generated from enum value: PERMISSION_EXTERNAL_SEARCH = 32;
   */
  EXTERNAL_SEARCH = 32,

  /**
   * @generated from enum value: PERMISSION_ROLE_MANAGE = 40;
   */
  ROLE_MANAGE = 40,

  /**
   * @generated from enum value: PERMISSION_USER_MANAGE = 41;
   */
  USER_MANAGE = 41,

  /**
   * Changing your own password, which is not an administrative act — every
   * operator should be able to do it, and one who cannot is stuck with
   * whatever they were handed.
   *
   * It needs a permission at all only because this application denies by
   * default: an RPC naming none is unreachable. So every role gets this one,
   * and new roles are created holding it.
   *
   * @generated from enum value: PERMISSION_PROFILE_PASSWORD = 42;
   */
  PROFILE_PASSWORD = 42,
}

/**
 * Describes the enum travplaces.v1.Permission.
 */
export const PermissionSchema: GenEnum<Permission> = /*@__PURE__*/
  enumDesc(file_travplaces_v1_authz, 0);

/**
 * The permission that implies this one. Holding an ancestor grants every
 * permission beneath it, so PERMISSION_ALL alone is a full-access role and
 * a new leaf permission is covered by it the day it is added rather than
 * the day someone remembers to re-grant it.
 *
 * Field numbers here are extension numbers on descriptor.proto, not field
 * numbers in this file — they only have to be unique among extensions of
 * EnumValueOptions.
 *
 * @generated from extension: optional travplaces.v1.Permission parent_permission = 100000;
 */
export const parent_permission: GenExtension<EnumValueOptions, Permission> = /*@__PURE__*/
  extDesc(file_travplaces_v1_authz, 0);

/**
 * How the permission is named to an operator in the admin console. The
 * enum name is a constant, not a label: nobody should be shown
 * "PERMISSION_TAXONOMY_WRITE".
 *
 * @generated from extension: string display_name = 100001;
 */
export const display_name: GenExtension<EnumValueOptions, string> = /*@__PURE__*/
  extDesc(file_travplaces_v1_authz, 1);

/**
 * One line on what holding it allows, shown beside the name.
 *
 * @generated from extension: string description = 100002;
 */
export const description: GenExtension<EnumValueOptions, string> = /*@__PURE__*/
  extDesc(file_travplaces_v1_authz, 2);

/**
 * What the caller must hold to invoke this method.
 *
 * Repeated, and evaluated as an AND of ORs: the caller must satisfy every
 * PermissionRequirement listed, and satisfies one by holding any permission
 * it names (or an ancestor of one). A single entry — the common case — reads
 * as "any of these".
 *
 * Unlike famtrak, omitting this option does not mean "open". It means the
 * method is unreachable, and the server will not start with one like that
 * registered.
 *
 * @generated from extension: repeated travplaces.v1.PermissionRequirement required_permissions = 100001;
 */
export const required_permissions: GenExtension<MethodOptions, PermissionRequirement[]> = /*@__PURE__*/
  extDesc(file_travplaces_v1_authz, 3);

